module.exports = __webpack_public_path__ + "static/media/delivery.c0205a6a.png";